<template>
  <Section id="contact" tone="muted" pad-y="lg">
    <Container>
      <header class="mb-8 flex flex-col gap-3 md:max-w-2xl">
        <h2 class="text-3xl font-extrabold text-ink-strong md:text-4xl">
          {{ t('sections.contact.title') }}
        </h2>
        <p class="text-base text-ink-muted">{{ t('sections.contact.subtitle') }}</p>
      </header>
      <Card tone="default" padding="lg">
        <LeadForm
          source="home.contact"
          :fields="['name', 'phone', 'email', 'message']"
          :submit-label="t('cta.submitLead')"
          @submitted="submitForm"
        />
      </Card>
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import Card from '@/components/primitives/Card.vue';
import LeadForm from '@/components/domain/LeadForm.vue';
import { sendBafsyLetter, sendUserLetter } from '@/helpers/notificationMethods';
import { SubmitResult } from '@/types/types';
import { LeadFormFieldKey, LeadFormValues } from '@/lib/forms/buildLeadPayload';
import { yaTrackEvent } from '@/lib/metrics';

const { t } = useI18n();

const submitForm = (payload: {
  result: SubmitResult;
  fields: LeadFormValues;
  keys: readonly LeadFormFieldKey[];
}) => {
  const currentFields = payload.keys.reduce<Record<string, unknown>>(
    (obj: Record<LeadFormFieldKey, unknown>, key: LeadFormFieldKey) => {
      obj[key] = payload.fields[key];

      return obj;
    },
    {},
  );

  yaTrackEvent('NewSiteBidSendSuccess');
  sendBafsyLetter('projectImplementation', currentFields);
  sendUserLetter('projectImplementation', payload.fields.email);
};
</script>
